export default __webpack_public_path__ + "static/media/arrow_left.6d682b37.svg";